import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Home';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4697 3.21967C11.7626 2.92678 12.2375 2.92678 12.5304 3.21967L22.2804 12.9697C22.4949 13.1842 22.559 13.5068 22.4429 13.787C22.3268 14.0673 22.0534 14.25 21.75 14.25H18.75V20.25C18.75 20.6642 18.4142 21 18 21H14.25C13.8358 21 13.5 20.6642 13.5 20.25V15H10.5V20.25C10.5 20.6642 10.1642 21 9.75002 21H6.00002C5.58581 21 5.25002 20.6642 5.25002 20.25V14.25H2.25002C1.94668 14.25 1.6732 14.0673 1.55711 13.787C1.44103 13.5068 1.50519 13.1842 1.71969 12.9697L11.4697 3.21967ZM4.06068 12.75H6.00002C6.41424 12.75 6.75002 13.0858 6.75002 13.5V19.5H9.00002V14.25C9.00002 13.8358 9.33581 13.5 9.75002 13.5H14.25C14.6642 13.5 15 13.8358 15 14.25V19.5H17.25V13.5C17.25 13.0858 17.5858 12.75 18 12.75H19.9394L12 4.81066L4.06068 12.75Z" fill="currentColor"/>
  </svg>
`;

const HomeIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.4697 3.21967C11.7626 2.92678 12.2375 2.92678 12.5304 3.21967L22.2804 12.9697C22.4949 13.1842 22.559 13.5068 22.4429 13.787C22.3268 14.0673 22.0534 14.25 21.75 14.25H18.75V20.25C18.75 20.6642 18.4142 21 18 21H14.25C13.8358 21 13.5 20.6642 13.5 20.25V15H10.5V20.25C10.5 20.6642 10.1642 21 9.75002 21H6.00002C5.58581 21 5.25002 20.6642 5.25002 20.25V14.25H2.25002C1.94668 14.25 1.6732 14.0673 1.55711 13.787C1.44103 13.5068 1.50519 13.1842 1.71969 12.9697L11.4697 3.21967ZM4.06068 12.75H6.00002C6.41424 12.75 6.75002 13.0858 6.75002 13.5V19.5H9.00002V14.25C9.00002 13.8358 9.33581 13.5 9.75002 13.5H14.25C14.6642 13.5 15 13.8358 15 14.25V19.5H17.25V13.5C17.25 13.0858 17.5858 12.75 18 12.75H19.9394L12 4.81066L4.06068 12.75Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: HomeIcon,
  IconSvg: IconSvg
} as IconType;
